

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.BK_bO2tL.js","_app/immutable/chunks/cL9VaPgy.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/chunks/Dj1UN0wv.js","_app/immutable/chunks/Bkiwg8SD.js","_app/immutable/chunks/Cz-4yBSw.js"];
export const stylesheets = [];
export const fonts = [];
